import { render } from "./HomePrincipal.vue?vue&type=template&id=011d4822&scoped=true"
import script from "./HomePrincipal.vue?vue&type=script&lang=js"
export * from "./HomePrincipal.vue?vue&type=script&lang=js"

import "./HomePrincipal.vue?vue&type=style&index=0&id=011d4822&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011d4822"]])

export default __exports__